import React,{useState, useEffect} from 'react';
import TagBox from '../common/Util/TagBox';

import ContentModal from './modal/ContentModal';
import MessageModal from './modal/MessageModal';
import MessageModifyModal from './modal/MessageModifyModal';

import PropTypes from 'prop-types';
import { tsConstructSignatureDeclaration } from '@babel/types';


// [{message: message, contentId: id, contentTitle: title, check: check, lowTagList: lowTagList}];
// check = message or content
export default function ScheduleShowLowTag(param) {
    const curUrl = window.location.href;
    var result = '';
    // if( curUrl.indexOf('ScheduleCreateMessage') > -1) {
    //     result  = 'message';
    // } else {
    //     result = 'content';
    // } 
    // ScheduleRightSidebar
    if( param.contentCheck == "content") {
        result  = 'content';
    } else {
        result = 'message';
    } 



    const [sendData, setSendData] = useState([]);
    const [content, setContent] = useState("");
    const [message, setMessage] = useState("");
    const [number, setNumber] = useState(0);
    const [messageNumber, setMessageNumber] = useState(0);
    const [check, setCheck] = useState(false);
    const [contentModifyCheck, setContentModifyCheck] = useState();

    useEffect(() => {
        if(param.sendData !== [] && param.sendData !== "") {
            setSendData(param.sendData);
        }
    }, [param.sendData])


    //sendData에 저장된 content관련값 초기화
    const contentDelete = (sendDataNumber, contentNumber) => {
        var temp = "";
        if(sendData[sendDataNumber].contentList.length === 1) {
            sendData[sendDataNumber].contentId = ""; 
            sendData[sendDataNumber].contentTitle = "";
            sendData[sendDataNumber].check = "";
            setContent("");
        }
        temp = sendData[sendDataNumber].contentList;
        temp.splice(contentNumber, 1);
        sendData[sendDataNumber].contentList = temp;
        setContent(content+"__");
        setSendData(sendData);
    }

    const contentModify = (sendDataNumber, contentNumber) => {
        // 컨텐츠 수정시 집어넣을 위치를 저장
        setContentModifyCheck([sendDataNumber, contentNumber])
        setNumber(sendDataNumber);
    }

    //sendData에 저장된 message관련값 초기화
    const messageDelete = (sendDataNumber, messageListNumber) => {
        var temp = "";
        if(sendData[sendDataNumber].messageList.length === 1) {
            sendData[sendDataNumber].message = "";
            sendData[sendDataNumber].check = "";
            setMessage("");
        }
        temp = sendData[sendDataNumber].messageList;
        temp.splice(messageListNumber, 1);
        sendData[sendDataNumber].messageList = temp;
        setSendData(sendData);
        // sendData값이 수정되게하기 위해서 한번더 set함
        setMessage(message+"__");
    }

    const messageModify = (sendDataNumber, messageListNumber) => {
        setMessageNumber(messageListNumber);
        setNumber(sendDataNumber);
        setMessage(sendData[sendDataNumber].messageList[messageListNumber]);
    }

    //생성된 하위태그 삭제
    const lowTagDelete = (i) => {
        var temp = sendData.filter((data, value) => {
            if(i !== value) {
                return Object.keys(data);
            }
        });
        setSendData(temp);
        setCheck(!check);

    }
    useEffect(() => {
        param.callbackSendData(sendData);
    }, [sendData])

    // ScheduleRightSidebar
    useEffect(() => {
        if(param.clear !== undefined) {
            setSendData([]);
            setContent("");
            setMessage("");
            setNumber(0);
            setMessageNumber(0);
            setCheck(false);
            setContentModifyCheck();
        }
        
    }, [param.clear])

    //sendDate 몇번째값이 변경되는지 알기위해서 사용
    const dataIndexCheck = (i) => {
        setNumber(i);
    }

    const callbackMessage = (message) => {
        sendData[number].messageList.push(message);
        sendData[number].message = message;
        sendData[number].check = "message";
        setMessage(message);
        setSendData(sendData);
    }

    const callbackModifyMessage = (message) => {
        sendData[number].messageList[messageNumber] = message;
        setSendData(sendData);
        setMessageNumber(-1);
    }

    const callbackContent = (inputContent) => {
        setCheck(!check);
        //컨텐츠 수정시 받은 컨텐츠
        if(contentModifyCheck !== undefined) {
            //contentNumber = [sendDataNumber, contentNumber]
            var sendDataNumber = contentModifyCheck[0];
            var contentNumber = contentModifyCheck[1]
            sendData[sendDataNumber].contentList.splice(contentNumber, 1,{contentId: inputContent.id, contentTitle: inputContent.title});

        } else {
            sendData[number].contentList.push({contentId: inputContent.id, contentTitle: inputContent.title});
        }
        
        sendData[number].contentId = inputContent.id;
        sendData[number].contentTitle = inputContent.title;
        sendData[number].check = "content";
        setSendData(sendData);
    }

    const callbackLowTagList = (lowTagList, dataNumber) => {
        var str = '';
        var temp = sendData;
        lowTagList.map((logTag, i) => {
            if(i === 0) {
                str = logTag.id;
            } else {
                str = str+","+logTag.id;
            }
        })
        temp[dataNumber].lowTag = str;
        param.callbackSendData(temp)
    }

    return(
        <div>
            {
                sendData.map((data, i) => (
                    <div className="card" key={i}>
                        {/* content header */}
                        <div className="card-header contentColor">
                            <div className="float-right">
                                <ul className="nav nav-pills">
                                    {/* 컨텐츠 추가를 누를시 */}
                                    {
                                        (data.check === "" && result === "message") && <li className="nav-item dropdown">
                                                                <a className="dropdown-toggle" data-toggle="dropdown">
                                                                    <span className="caret"></span>
                                                                </a>
                                                                <div className="dropdown-menu dropdown-menu-right">
                                                                    <a className="dropdown-item" data-toggle="modal" data-target="#messageModal" onClick={() => dataIndexCheck(i)}>메시지</a>
                                                                    <div className="dropdown-divider"></div>
                                                                    <a className="dropdown-item" onClick={() => lowTagDelete(i)}>삭제</a>
                                                                </div>
                                        
                                                            </li>
                                    
                                    }
                                    {
                                        (data.check === "" && result === "content") && <li className="nav-item dropdown">
                                                                <a className="dropdown-toggle" data-toggle="dropdown">
                                                                    <span className="caret"></span>
                                                                </a>
                                                                <div className="dropdown-menu dropdown-menu-right">
                                                                    <a className="dropdown-item" data-toggle="modal" data-target="#contentModal" onClick={() => dataIndexCheck(i)}>컨텐츠</a>
                                                                    <div className="dropdown-divider"></div>
                                                                    
                                                                    <a className="dropdown-item" onClick={() => lowTagDelete(i)}>삭제</a>
                                                                </div>
                                        
                                                            </li>
                                    
                                    }
                                    {/* 자동생성된 하위태그 */}
                                    {
                                        data.check === "message" && <li className="nav-item dropdown">
                                                                        <a className="dropdown-toggle" data-toggle="dropdown">
                                                                            <span className="caret"></span>
                                                                        </a>
                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                            <a className="dropdown-item" data-toggle="modal" data-target="#messageModal" onClick={() => dataIndexCheck(i)}>메시지 추가</a>
                                                                            <div className="dropdown-divider"></div>
                                                                            <a className="dropdown-item" onClick={() => lowTagDelete(i)}>삭제</a>
                                                                        </div>
                                                
                                                                    </li>
                                    }
                                    {
                                        data.check === "content" && <li className="nav-item dropdown">
                                                                        <a className="dropdown-toggle" data-toggle="dropdown">
                                                                            <span className="caret"></span>
                                                                        </a>
                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                            <a className="dropdown-item" data-toggle="modal" data-target="#contentModal" onClick={() => dataIndexCheck(i)}>컨텐츠 추가</a>
                                                                            <div className="dropdown-divider"></div>
                                                                            <a className="dropdown-item" onClick={() => lowTagDelete(i)}>삭제</a>
                                                                        </div>
                                                
                                                                    </li>
                                    }
                                </ul>
                            </div>
                            <h3 className="card-title">하위 태그</h3>
                        </div>
                        <div className="card-body">
                            <div>
                                <TagBox title="검색어" readCheck={false} tags={data.lowTagList} dataNumber={i} callbackLowTagList={callbackLowTagList}></TagBox>
                            </div>
                            {
                                data.check === "content" && data.contentList.map((content, j) => (
                                    <div className="d-flex margin-top ml-3 col-12" key={j}>
                                        <div className="text col-10">
                                            <span className="d-block">{content.contentTitle}</span>
                                        </div>
                                        <div className="icon-center col-2 d-flex">
                                            <div>
                                                <button type="button" className="btn btn-default btn-white p-2" data-toggle="modal" data-target="#contentModal" onClick={() => contentModify(i, j)}>
                                                <i className="fas fa-edit"></i>
                                                </button>
                                                <button type="button" className="btn btn-default btn-white p-2" onClick={() => contentDelete(i, j)}>
                                                    <i className="far fa-trash-alt" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div> 
                                )) 
                            }
                            {
                                data.check === "message" && data.messageList.map((message, j) => (
                                    <div className="d-flex margin-top ml-3 col-12" key={j}>
                                        <div className="text col-10">
                                            <span className="d-block">{message}</span>
                                        </div>
                                        <div className="icon-center col-2 d-flex">
                                            <button type="button" className="btn btn-default btn-white p-2" data-toggle="modal" data-target="#messageModifyModal" onClick={() => messageModify(i, j)}>
                                            <i className="fas fa-edit"></i>
                                            </button>
                                            <button type="button" className="btn btn-default btn-white p-2" onClick={() => messageDelete(i, j)}>
                                                <i className="far fa-trash-alt" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>
                                ))
                            }
                            {
                                data.check === "" && <div></div>
                            }
        
                        </div>
                            
                    </div>
                ))
            }
            {/* 모달 */}
            <ContentModal callbackContent={callbackContent}></ContentModal>
            <MessageModal callbackMessage={callbackMessage} data={""}></MessageModal>
            <MessageModifyModal callbackModifyMessage={callbackModifyMessage} data={message}></MessageModifyModal>
        </div>
        
    );
}

ScheduleShowLowTag.propTypes = {
    sendData: PropTypes.any,
    callbackSendData: PropTypes.func
  };